import { useState } from 'react';
import BasicCard from '../../../components/basicCard/BasicCard';

type PriceProductCategoryCardProps = {
  name: string;
  id: number;
  mainCategory: string;
  category: string;
  subCategory?: string;
  description?: string;
  actionText?: string;
  action?: Function;
  handleCategoryClick?: (id: number, name: string) => void;
  isSelected?: boolean;
};

const PriceProductCategoryCard = ({
  name,
  id,
  mainCategory,
  category,
  subCategory,
  description,
  actionText,
  action,
  handleCategoryClick,
  isSelected,
}: PriceProductCategoryCardProps) => {
  const [categorySelected, setCategorySelected] = useState<boolean>(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number>(0);

  const categoryClicked = (id: number, name: string) => {
    setCategorySelected(true);
    setSelectedCategoryId(id);
    handleCategoryClick?.(id, name);
  };

  const displayName = (() => {
    if (subCategory && category) {
      return `${mainCategory} > ${category} > ${subCategory}`;
    } else if (category) {
      return `${mainCategory} > ${category}`;
    } else {
      return mainCategory;
    }
  })();

  return (
    <>
      <div
        className="flex w-full flex-col gap-1 rounded-2xl border-gray-400 hover:cursor-pointer md:flex-row"
        key={id}
        onClick={() => categoryClicked?.(id, name)}
      >
        <BasicCard radius="lg" active={isSelected}>
          <div className="flex h-full flex-row items-center justify-start gap-1 p-2">
            <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-light-gray">
              <span className="text-lg font-semibold text-primary">
                {mainCategory.charAt(0).toUpperCase()}
              </span>
            </div>
            <div className="ml-2">
              <p className="max-h-12 overflow-hidden text-ellipsis text-sm" title={displayName}>
                {displayName}
              </p>
            </div>
          </div>
        </BasicCard>
      </div>
    </>
  );
};

export default PriceProductCategoryCard;
